var map = {
	"./": 88,
	"./documentEditTranslation": 162,
	"./documentEditTranslation.ts": 162,
	"./index": 88,
	"./index.ts": 88,
	"./languages": 74,
	"./languages.ts": 74,
	"./pl": 163,
	"./pl.ts": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;